import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { hooks } from "@engelvoelkersamericas/common-story-ui";
import { Provider as VideoProvider } from "./context/videoContext";
import { Amplify } from "aws-amplify";
import devOutputs from "@engelvoelkersamericas/notifications-service/amplify_outputs.dev.json";
import prodOutputs from "@engelvoelkersamericas/notifications-service/amplify_outputs.prod.json";

import { notificationsStore } from "./mobx/stores/notifications-store";
const { ProfileProvider, GlobalProvider } = hooks;

const amplifyOutputs = window.location.hostname.includes("evipscloud")
  ? prodOutputs
  : devOutputs;
Amplify.configure(amplifyOutputs);
notificationsStore.configure(amplifyOutputs.data.url);
ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <ProfileProvider>
        {/* <VideoProvider> */}
        <App />
        {/* </VideoProvider> */}
      </ProfileProvider>
    </GlobalProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
